var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('div',{staticClass:"goal-outline"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"gbe-calculator",attrs:{"src":"/GBE-Calculator-Logo-White.png"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }